import React, { useEffect } from "react";
import MyContext from "../../../api/context/my-context";
import $ from "jquery";

const SideMenuProcess = () => {
  return (
    <MyContext.Consumer>
      {(context) => (
        <div>
          <div
            style={{
              display:
                context.storeProcess.completeSuccess &&
                context.storeProcess.successRowCount != 0
                  ? "block"
                  : "none",
            }}
          >
            <a
              role="button"
              class="button process-continuing"
              id="mappen_beheren"
            >
              <span className="process-continuing-svg"></span>
              <span className="text">
                {context.storeProcess.successRowCount}
              </span>
            </a>
          </div>
          <div
            style={{
              display: context.storeProcess.completeError ? "block" : "none",
            }}
          >
            <a
              role="button"
              class="button process-continuing error"
              id="mappen_beheren"
              onClick={() => {
                $("#side-menu-process-error-modal").modal("show");
              }}
            >
              <span className="process-continuing-svg error">
                <span className="exclamation">
                  <span>.</span>
                </span>
              </span>
              <span className="text">{context.storeProcess.errorRowCount}</span>
            </a>
          </div>
        </div>
      )}
    </MyContext.Consumer>
  );
};

export default SideMenuProcess;
